import type { ChatFileDownload } from '../../types';
import { formatSize } from './helpers';

function getDownloadIconPath(contentType: string): string {
  const isImage = contentType.startsWith('image/');
  const isPdf = contentType === 'application/pdf';
  if (isPdf) {
    return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/><path d="M10 13h4"/><path d="M10 17h4"/><path d="M10 9h1"/>';
  }
  if (isImage) {
    return '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>';
  }
  return '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/><path d="M14 2v6h6"/><path d="M12 18v-6"/><path d="M9 15l3 3 3-3"/>';
}

export function DownloadCard({ file }: { file: ChatFileDownload }) {
  const iconPath = getDownloadIconPath(file.contentType);
  return (
    <a
      className="file-download-card"
      href={file.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        className="file-download-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        dangerouslySetInnerHTML={{ __html: iconPath }}
      />
      <div className="file-download-info">
        <span className="file-download-name">{file.filename}</span>
        <span className="file-download-size">{formatSize(file.size)}</span>
      </div>
    </a>
  );
}
